import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { AiManagementColumn } from 'store/modules/ai_management_store/types';
import AiManagementModalHeader from 'components/molecules/ai_management_modal_header';
import { Container } from './styles';

interface AiManagementColumnPickerModalProps {
  title: string;
  columns: AiManagementColumn[];
  show: boolean;
  saving: boolean;
  onClose: () => void;
  onConfirm: (columnId?: number) => void;
}

const AiManagementColumnPickerModal: React.FC<AiManagementColumnPickerModalProps> = ({
  title,
  columns,
  show,
  saving,
  onClose,
  onConfirm,
}) => {
  const [columnId, setColumnId] = useState<number | null>(null);

  useEffect(() => {
    if (!show) return;
    setColumnId(columns[0]?.id ?? null);
  }, [show]);

  return (
    <Modal show={show} onHide={onClose} size="sm" centered>
      <Container>
        <AiManagementModalHeader title={title} onClose={onClose} />

        <div className="picker-body px-4 py-4">
          {columns.length === 0 && (
            <div className="text-muted small">Nenhuma coluna disponível.</div>
          )}
          {columns.map((column) => (
            <div key={column.id} className="form-check mb-3">
              <input
                className="form-check-input"
                type="radio"
                name="column-picker"
                id={`column-picker-${column.id}`}
                checked={columnId === column.id}
                onChange={() => setColumnId(column.id)}
              />
              <label className="form-check-label" htmlFor={`column-picker-${column.id}`}>
                {column.name}
              </label>
            </div>
          ))}
        </div>

        <div className="picker-footer d-flex justify-content-center border-top px-4 py-3">
          <button
            type="button"
            className="btn btn-primary px-4"
            onClick={() => onConfirm(columnId ?? undefined)}
            disabled={saving || (columns.length > 0 && !columnId)}
          >
            {saving ? 'Salvando...' : 'Salvar'}
          </button>
        </div>
      </Container>
    </Modal>
  );
};

export default AiManagementColumnPickerModal;
